define('models/conversation/custom-message',[
    'underscore',
    'backbone',
    // src
    'utils',
    'services/api',
    'services/i18n'
], function(_, Backbone, U, API, i18n) {

    var MCustomMessage = Backbone.Epoxy.Model.extend({
        idAttribute: '_id',
        urlRoot: API.url("custom-messages/"),
        defaults: {
            title: "",
            message: "",
            defaultWelcomeMessage: false
        },

        computeds: {
            defaultWelcomeMessageSubtitle: function() {
                return this.get('defaultWelcomeMessage') ? i18n.t('conversation:default-welcome-message-label') : '';
            }
        }
        // getUnit: function() {
        //     return this.get('unit');
        // },
    });

    // Return the model for the module
    return MCustomMessage;
});

